import React from 'react'
import { withIcon } from '../../withIcon'

function MobileIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 3.625C7.63533 3.625 7.28559 3.76987 7.02773 4.02773C6.76987 4.28559 6.625 4.63533 6.625 5V19C6.625 19.3647 6.76987 19.7144 7.02773 19.9723C7.28559 20.2301 7.63533 20.375 8 20.375H16C16.3647 20.375 16.7144 20.2301 16.9723 19.9723C17.2301 19.7144 17.375 19.3647 17.375 19V5C17.375 4.63533 17.2301 4.28559 16.9723 4.02773C16.7144 3.76987 16.3647 3.625 16 3.625H13.5C13.5785 3.72946 13.625 3.8593 13.625 4C13.625 4.34518 13.3452 4.625 13 4.625H11C10.6548 4.625 10.375 4.34518 10.375 4C10.375 3.8593 10.4215 3.72946 10.5 3.625H8ZM6.14384 3.14384C6.63613 2.65156 7.30381 2.375 8 2.375H16C16.6962 2.375 17.3639 2.65156 17.8562 3.14384C18.3484 3.63613 18.625 4.30381 18.625 5V19C18.625 19.6962 18.3484 20.3639 17.8562 20.8562C17.3639 21.3484 16.6962 21.625 16 21.625H8C7.30381 21.625 6.63613 21.3484 6.14384 20.8562C5.65156 20.3639 5.375 19.6962 5.375 19V5C5.375 4.30381 5.65156 3.63613 6.14384 3.14384ZM12 16.375C12.3452 16.375 12.625 16.6548 12.625 17V17.01C12.625 17.3552 12.3452 17.635 12 17.635C11.6548 17.635 11.375 17.3552 11.375 17.01V17C11.375 16.6548 11.6548 16.375 12 16.375Z" fill={color}/>
    </svg>
  )
}

export default withIcon(MobileIcon)
